import imageLanding from "@/assets/image_landing.webp";
import { CalendarIcon, PinIcon } from "@/components/icons";
import { formatAmount, formatDateTimeRange } from "@/lib/formatting";
import type { Course } from "@/types";

/** Read-only course summary used by the student enrollment/cancel/confirm
 *  pages: house image on top, then type + suggested amount on the left
 *  and dates/times + location on the right. */
export default function CourseSummaryCard({ course }: { course: Course }) {
  const houseName = course.house_name as string | null;
  const houseAddress = course.house_address as string | null;
  const categoryName = course.category_name as string | null;
  const location = [houseName, houseAddress].filter(Boolean).join(", ");

  return (
    <div className="overflow-hidden rounded-2xl border border-ink">
      <img
        src={course.house_image_url ?? imageLanding}
        alt={houseName ?? course.name ?? "Curso"}
        className="aspect-[2.4/1] w-full object-cover"
      />
      <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-2 p-4">
        <div className="flex min-w-0 flex-col gap-1">
          <h2 className="font-sans text-base font-semibold text-ink uppercase">
            {categoryName || "-"}
          </h2>
          <p className="font-sans text-sm font-semibold text-ink">
            Aporte: {formatAmount(course.amount)}
          </p>
        </div>

        <div className="flex flex-col gap-1">
          <p className="flex items-center gap-1 font-sans text-xs font-light text-ink/80">
            <CalendarIcon className="h-3.5 w-3.5 shrink-0" />
            {formatDateTimeRange(
              course.start_date,
              course.end_date,
              course.start_time,
              course.end_time,
            )}
          </p>
          {location && (
            <p className="flex items-center gap-1 font-sans text-xs font-light text-ink/80">
              <PinIcon className="h-3.5 w-3.5 shrink-0" />
              {location}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
